module.exports = __webpack_public_path__ + "img/file-add.3c3047ca.svg";